import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import Spinner from './Spinner';
import FestiveEffects from './FestiveEffects';
import { startPublicThemeLiveSync } from '../utils/siteTheme';

function Layout({ children }) {
  const location = useLocation();

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    // Live theme/announcement sync — no page refresh needed
    return startPublicThemeLiveSync({ intervalMs: 10000 });
  }, []);

  useEffect(() => {
    // Hide spinner after page loads
    const spinner = document.getElementById('spinner');
    if (spinner) {
      setTimeout(() => {
        spinner.classList.remove('show');
      }, 100);
    }
  }, []);

  return (
    <>
      <Spinner />
      <FestiveEffects />
      <Navbar />
      <main>{children}</main>
      <Footer />
    </>
  );
}

export default Layout;
